const Spinner = (props:any)=>{
    return(<div className={props.className}></div>)
}
export default Spinner;